import { render, staticRenderFns } from "./ResetUserPassword.vue?vue&type=template&id=dd6f5366&scoped=true&"
import script from "./ResetUserPassword.vue?vue&type=script&lang=js&"
export * from "./ResetUserPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6f5366",
  null
  
)

export default component.exports